module.exports = __webpack_public_path__ + "img/retraités_small.1e1d6bf1.jpg";